<template>
	<img	  
	  :src="url"
	></img>
</template>

<script>
export default {
  name: 'ka-image',
  props: {
    url: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 img{
 	height: 90vh;
 }
</style>
